<div class="col-sm-11 mx-auto">
  <div class="row">
    <h4 class="col">{{ "CameraSupervision" | translate }}</h4>

    <div class="col">
      @if (user.roleLevel > 50) {
        <button type="button" routerLink="/camera-supervision/new-visit" class="btn btn-primary float-right">
          {{ "SCHEDULE" | translate }}
        </button>
      }

      @if (user.roleLevel === 101 || user.roleLevel === 200) {
        <button
          type="button"
          class="btn secondaryBtnGrayBg float-right mr-3"
          data-testid="camera-configuration-button"
          routerLink="/camera-configuration"
          >
          <span class="fa-solid fa-gear" style="color: #4f4f4f"></span>
          {{ "CAMERA_CONFIGURATION_LINK" | translate }}
        </button>
      }
    </div>
  </div>

  <hr />

  @if (allVisits) {
    <div class="row" style="margin-bottom: -10px">
      <div class="col-sm-12">
        <div class="form-inline mb-2 mt-3 filterContent" role="toolbar" aria-label="">
          <div class="row ml-1 mr-2">
            <div class="form-container">
              <label class="date-label">
                {{ "REPORT_START_DATE" | translate}}
              </label>
              <mat-form-field appearance="outline" class="dateFilterSelect">
                <input
                  id="supervisionStartDate"
                  placeholder="{{'REPORT_START_DATE' | translate}}"
                  matInput [(ngModel)]="filterStartDay"
                  [min]="filterMinDate"
                  [max]="filterEndDay"
                  [matDatepicker]="filterStartDayPicker"
                  (dateChange)="onDateChanged()" />
                  <mat-datepicker-toggle matSuffix [for]="filterStartDayPicker"></mat-datepicker-toggle>
                  <mat-datepicker #filterStartDayPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <p class="mx-2" style="margin-top: 8px">-</p>
              <div class="form-container">
                <label class="date-label">
                  {{"REPORT_END_DATE" | translate}}
                </label>
                <mat-form-field appearance="outline" class="dateFilterSelect">
                  <input
                    id="supervisionEndDate"
                    placeholder="{{'REPORT_END_DATE' | translate}}"
                    matInput [(ngModel)]="filterEndDay"
                    [min]="filterStartDay"
                    [max]="filterMaxDate"
                    [matDatepicker]="filterEndDayPicker"
                    (dateChange)="onDateChanged()" />
                    <mat-datepicker-toggle matSuffix [for]="filterEndDayPicker"></mat-datepicker-toggle>
                    <mat-datepicker #filterEndDayPicker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
              <div class="vertical-line ml-2"></div>
              <div class="ml-3 time-select-group">
                <div class="form-group time-select">
                  <label class="time-label">
                    {{ "REPORT_START_TIME" | translate}}
                  </label>
                  <input id="supervisionStartTime" type="time" class="form-control clock-icon" [(ngModel)]="filterStartTime" (change)="applyFilters()" />
                </div>
                <p class="mx-2" style="margin-top: 30px">-</p>
                <div class="form-group time-select">
                  <label class="time-label">
                    {{"REPORT_END_TIME" | translate}}
                  </label>
                  <input id="supervisionEndTime" type="time" class="form-control clock-icon" [(ngModel)]="filterEndTime" (change)="applyFilters()" />
                </div>
              </div>
              <div class="vertical-line ml-4 mr-3"></div>
              @for (checkbox of weekDayFilterList; track checkbox) {
                <mat-checkbox
                  class="mb-3"
                  [value]="checkbox"
                  [checked]="checkbox.isChecked"
                  [(ngModel)]="checkbox.isChecked"
                  (change)="applyFilters()"> {{ checkbox.title | translate }}
                </mat-checkbox>
              }
            </div>
          </div>
        </div>
      }

      <div class="col-sm-12 mb-4">
        <div class="row">
          <p class="mt-2 ml-2" style="font-weight: 500; color: #797979">
            {{ "FILTER_BY" | translate }}:
          </p>

          @if (advancedFilter.location.filterList) {
            <div class="form-group ml-3">
              <ngx-bootstrap-multiselect
                [options]="advancedFilter.location.filterList"
                [settings]="advancedFilter.settings"
                [texts]="advancedFilter.location.texts"
                [(ngModel)]="advancedFilter.location.selectedList"
                (ngModelChange)="applyFilters()"
                name="advancedFilterLocations">
              </ngx-bootstrap-multiselect>
            </div>
          }

          @if (advancedFilter.cameraGroup.filterList) {
            <div class="form-group ml-3">
              <ngx-bootstrap-multiselect
                [options]="advancedFilter.cameraGroup.filterList"
                [settings]="advancedFilter.settings"
                [texts]="advancedFilter.cameraGroup.texts"
                [(ngModel)]="advancedFilter.cameraGroup.selectedList"
                (ngModelChange)="applyFilters()"
                name="advancedFilterCameraGroupName">
              </ngx-bootstrap-multiselect>
            </div>
          }

          @if (advancedFilter.receiverGroup.filterList) {
            <div class="form-group ml-3">
              <ngx-bootstrap-multiselect
                [options]="advancedFilter.receiverGroup.filterList"
                [settings]="advancedFilter.settings"
                [texts]="advancedFilter.receiverGroup.texts"
                [(ngModel)]="advancedFilter.receiverGroup.selectedList"
                (ngModelChange)="applyFilters()"
                name="advancedFilterReceiverGroup">
              </ngx-bootstrap-multiselect>
            </div>
          }

          <!--
          <div class="form-group ml-3" *ngIf="advancedFilter.alertRoute.filterList">
            <ngx-bootstrap-multiselect
              [options]="advancedFilter.alertRoute.filterList"
              [settings]="advancedFilter.settings"
              [texts]="advancedFilter.alertRoute.texts"
              [(ngModel)]="advancedFilter.alertRoute.selectedList"
              (ngModelChange)="applyFilters()"
              name="advancedFilterAlertRoute">
            </ngx-bootstrap-multiselect>
          </div>
          -->

          <div class="form-group ml-3">
            <button class="btn btn-outline-primary btn-sm" (click)="clearFilters()">
              <span class="fa-light fa-xmark"></span>
              {{ "CLEAR_FILTERS" | translate }}
            </button>
          </div>
        </div>
      </div>

      @if (allVisits) {
        <div>
          <div>
            <h6>{{ "UPCOMING_VISITS" | translate }}</h6>
            @if (allVisits.length > 0) {
              <table class="table table-hover mt-2" style="background-color: #ffffff">
                <thead>
                  <tr>
                    <th>
                      {{ "VISIT_TYPE" | translate }}
                    </th>
                    <th>{{ "DAY" | translate }}</th>
                    <th>{{ "TIME" | translate }}</th>
                    <th>{{ "DATE" | translate }}</th>
                    <th>
                      {{ "CAMERAGROUP_NAME" | translate }}
                    </th>
                    <th>
                      {{ "RECEIVER_GROUPS" | translate }}
                    </th>
                    <th>
                      {{ "LOCATION" | translate }}
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (visit of allVisits; track visit) {
                    <tr>
                      <td>
                        <div>
                          @if (visit.visitType) {
                            <span>
                              <span class="fa-light fa-fw fa-lg" [ngClass]="visit.visitType | cameraVisitIcon"></span>
                              {{ visit.visitType | translate }}
                            </span>
                          }
                        </div>
                        @if (visit.isPaused) {
                          <div class= "ml-4" style="margin-top: 4px;">
                            <span style="background-color: #dc3545; color: white; padding: 2px 6px; border-radius: 3px; font-size: 11px; font-weight: bold; display: inline-block; text-transform: uppercase;">
                              {{ "PAUSED" | translate }}
                            </span>
                          </div>
                        }
                      </td>
                      <td class="capitalize">
                        {{ getWeekday(visit) }}
                      </td>
                      <td>{{ visit | function : getVisitDurationTimes }}</td>
                      <td>{{ visit.startDate | date : "dd/MM/yyyy" }}</td>
                      <td>
                        {{ visit.cameraGroupName }}
                        @for (id of visit.discoveryNames; track id) {
                          <li class="ml-2">
                            {{ id }}
                          </li>
                        }
                      </td>
                      <td>
                        @if (!visit.userGroups || visit.userGroups.length === 0) {
                          <p class="m-0">-</p>
                        }
                        @if (visit.userGroups && visit.userGroups.length === 1) {
                          <p class="m-0">{{ visit.userGroups[0] | function : getUserGroupName : advancedFilter.receiverGroup.filterList }}</p>
                        } @else {
                          @for (groupId of visit.userGroups; track groupId) {
                            <li>
                              {{ groupId | function : getUserGroupName : advancedFilter.receiverGroup.filterList }}
                            </li>
                          }
                        }
                      </td>
                      <td>{{ visit.locationId | visitLocation : advancedFilter.location.filterList }}</td>
                      <td>
                        @if (!visit.toBeDeleted && editingVisitId !== visit.id && user.roleLevel > 50) {
                          <div>
                            @if (user.roleLevel >= 100) {
                              <span class="cursorPointer fa-light fa-lg fa-fw fa-pen mr-2" (click)="startEditVisit(visit)"></span>
                            }
                            <span class="cursorPointer fa-light fa-lg fa-fw fa-trash-alt" (click)="visit.toBeDeleted = true"></span>
                          </div>
                        }
                        @if (visit.toBeDeleted) {
                          <div>
                            {{ "CONFIRM_VISIT_DELETE" | translate }}
                            <span class="cursorPointer fa-light fa-fw fa-xmark fa-lg text-danger" (click)="visit.toBeDeleted = false"></span>
                            <span class="cursorPointer fal fa-fw fa-lg fa-check text-success" (click)="deleteCameraVisit(visit)"></span>
                          </div>
                        }
                      </td>
                    </tr>
                    @if (editingVisitId === visit.id && editingVisitData) {
                      <tr>
                        <td colspan="8" class="p-3" style="background-color: #f8f9fa; border-top: 0;">
                          <div class="d-flex align-items-center">
                            <div class="flex-grow-1">
                              <div class="d-flex align-items-end flex-wrap">
                                <div class="mr-3">
                                  <label class="d-block mb-1">{{ "DAY" | translate }}</label>
                                  <input type="text" class="form-control form-control-sm capitalize" [value]="getWeekday(visit)" disabled />
                                </div>
                                <div class="mr-3">
                                  <label class="d-block mb-1">{{ "DATE_FROM" | translate }}</label>
                                  <input type="time" class="form-control form-control-sm" [(ngModel)]="editingVisitData.startTime" />
                                </div>
                                <div class="mr-3">
                                  <label class="d-block mb-1">{{ "VISIT_DURATION" | translate }}</label>
                                  <input type="number" class="form-control form-control-sm" [(ngModel)]="editingVisitData.duration"
                                    min="1" [attr.max]="visit.isNightowl ? 30 : null" style="width: 90px;"
                                    [class.is-invalid]="getDurationError(visit)" />
                                  </div>
                                  @if (!visit.isNightowl) {
                                    <div class="mr-3">
                                      <label class="d-block mb-1">{{ "EXTENSION_TIME" | translate }}</label>
                                      <input type="number" class="form-control form-control-sm" [(ngModel)]="editingVisitData.gracePeriod"
                                        min="0" style="width: 90px;"
                                        [class.is-invalid]="getGracePeriodError()" />
                                      </div>
                                    }
                                  </div>
                                  <div class="d-flex flex-wrap mt-1">
                                    <div class="text-danger small mr-3" [class.invisible]="!getDurationError(visit)">
                                      {{ getDurationError(visit) ? (getDurationError(visit) | translate) : '_' }}
                                    </div>
                                    @if (!visit.isNightowl) {
                                      <div class="text-danger small mr-3" [class.invisible]="!getGracePeriodError()">
                                        {{ getGracePeriodError() ? (getGracePeriodError() | translate) : '_' }}
                                      </div>
                                    }
                                    <div class="text-danger small" [class.invisible]="!checkEditOverlap(visit)">
                                      {{ "VISIT_OVERLAP_WARNING" | translate }}
                                    </div>
                                  </div>
                                </div>
                                <div class="flex-shrink-0">
                                  <button class="btn btn-sm btn-primary mr-1" (click)="submitEditVisit(visit)" [disabled]="editSavingInProgress || checkEditOverlap(visit) || hasEditRangeError(visit)">
                                    @if (editSavingInProgress) {
                                      <span class="fa-light fa-spinner fa-spin mr-1"></span>
                                    }
                                    {{ "SAVE" | translate }}
                                  </button>
                                  <button class="btn btn-sm btn-outline-secondary" (click)="cancelEditVisit()" [disabled]="editSavingInProgress">
                                    {{ "CANCEL" | translate }}
                                  </button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        }
                      }
                    </tbody>
                  </table>
                }
                @if (allVisits.length === 0) {
                  <p class="ml-3 mt-2">
                    {{ "NO_VISITS" | translate }}
                  </p>
                }
              </div>
            </div>
          }
          @if (!allVisits) {
            <div>
              <img class="fadeLoader centerLoader logoSmall" src="assets/img/loading_logo.svg" />
            </div>
          }
        </div>
